export var UiIconName = /* @__PURE__ */ ((UiIconName2) => {
  UiIconName2["AddBook"] = "Add_book";
  UiIconName2["Arrows_2xChevronLeft"] = "Arrows/2x_chevron_left";
  UiIconName2["Arrows_2xChevronRight"] = "Arrows/2x_chevron_right";
  UiIconName2["Arrows_2xDownChevron"] = "Arrows/2x_down_chevron";
  UiIconName2["Arrows_BottomAlignment"] = "Arrows/Bottom_Alignment";
  UiIconName2["Arrows_Compress"] = "Arrows/Compress";
  UiIconName2["Arrows_Connection1"] = "Arrows/Connection_1";
  UiIconName2["Arrows_Connection2"] = "Arrows/Connection_2";
  UiIconName2["Arrows_FillUp"] = "Arrows/Fill_Up";
  UiIconName2["Arrows_FillDown"] = "Arrows/Fill_down";
  UiIconName2["Arrows_Resize"] = "Arrows/Resize";
  UiIconName2["Arrows_SortBig"] = "Arrows/Sort_big";
  UiIconName2["Arrows_"] = "Arrows/__";
  UiIconName2["Arrows_BottomLeft"] = "Arrows/bottom_left";
  UiIconName2["Arrows_BottomRight"] = "Arrows/bottom_right";
  UiIconName2["Arrows_Code"] = "Arrows/code";
  UiIconName2["Arrows_Down"] = "Arrows/down";
  UiIconName2["Arrows_DownCircle"] = "Arrows/down_circle";
  UiIconName2["Arrows_DownGrowth"] = "Arrows/down_growth";
  UiIconName2["Arrows_Download"] = "Arrows/download";
  UiIconName2["Arrows_DownloadSecond"] = "Arrows/download_second";
  UiIconName2["Arrows_Enter"] = "Arrows/enter";
  UiIconName2["Arrows_Expand"] = "Arrows/expand";
  UiIconName2["Arrows_Forward"] = "Arrows/forward";
  UiIconName2["Arrows_Growth"] = "Arrows/growth";
  UiIconName2["Arrows_HorizontalAlignCenter"] = "Arrows/horizontal_align_center";
  UiIconName2["Arrows_HorizontalAlignment"] = "Arrows/horizontal_alignment";
  UiIconName2["Arrows_HorizontalArrows1"] = "Arrows/horizontal_arrows_1";
  UiIconName2["Arrows_HorizontalMaximize"] = "Arrows/horizontal_maximize";
  UiIconName2["Arrows_HorizontalMaximizeUnited"] = "Arrows/horizontal_maximize_united";
  UiIconName2["Arrows_LeftAlignment"] = "Arrows/left_alignment";
  UiIconName2["Arrows_LeftArrow"] = "Arrows/left_arrow";
  UiIconName2["Arrows_LeftArrowChev"] = "Arrows/left_arrow_chev";
  UiIconName2["Arrows_LeftCircle"] = "Arrows/left_circle";
  UiIconName2["Arrows_LowerLeft"] = "Arrows/lower_left";
  UiIconName2["Arrows_LowerRightArrow"] = "Arrows/lower_right_arrow";
  UiIconName2["Arrows_Move"] = "Arrows/move";
  UiIconName2["Arrows_NarrowingAngle"] = "Arrows/narrowing_angle";
  UiIconName2["Arrows_NarrowingHorizon"] = "Arrows/narrowing_horizon";
  UiIconName2["Arrows_Opposite"] = "Arrows/opposite";
  UiIconName2["Arrows_OppositeHorizon"] = "Arrows/opposite_horizon";
  UiIconName2["Arrows_Out"] = "Arrows/out";
  UiIconName2["Arrows_Play"] = "Arrows/play";
  UiIconName2["Arrows_ReloadFill"] = "Arrows/reload_fill";
  UiIconName2["Arrows_Reply"] = "Arrows/reply";
  UiIconName2["Arrows_Resize4Arrows"] = "Arrows/resize_4_arrows";
  UiIconName2["Arrows_ResizeCompress"] = "Arrows/resize_compress";
  UiIconName2["Arrows_ResizeFromCube"] = "Arrows/resize_from_cube";
  UiIconName2["Arrows_RightAlignment"] = "Arrows/right_alignment";
  UiIconName2["Arrows_RightArrow"] = "Arrows/right_arrow";
  UiIconName2["Arrows_RightArrowChev"] = "Arrows/right_arrow_chev";
  UiIconName2["Arrows_RightCircle"] = "Arrows/right_circle";
  UiIconName2["Arrows_ScrollUp"] = "Arrows/scroll_up";
  UiIconName2["Arrows_Shuffle"] = "Arrows/shuffle";
  UiIconName2["Arrows_SubdirectoryArrow"] = "Arrows/subdirectory_arrow";
  UiIconName2["Arrows_Table"] = "Arrows/table";
  UiIconName2["Arrows_TableFill"] = "Arrows/table_fill";
  UiIconName2["Arrows_Textarea"] = "Arrows/textarea";
  UiIconName2["Arrows_TopAlignment"] = "Arrows/top_alignment";
  UiIconName2["Arrows_TopRight"] = "Arrows/top_right";
  UiIconName2["Arrows_TurnDownLeft"] = "Arrows/turn_down_left";
  UiIconName2["Arrows_TurnDownRight"] = "Arrows/turn_down_right";
  UiIconName2["Arrows_TurnLeftDown"] = "Arrows/turn_left_down";
  UiIconName2["Arrows_TurnRightDown"] = "Arrows/turn_right_down";
  UiIconName2["Arrows_TurnUpLeft"] = "Arrows/turn_up_left";
  UiIconName2["Arrows_TurnUpRight"] = "Arrows/turn_up_right";
  UiIconName2["Arrows_UnitedResize"] = "Arrows/united_Resize";
  UiIconName2["Arrows_UnitedExpand"] = "Arrows/united_expand";
  UiIconName2["Arrows_Up2xChevron"] = "Arrows/up_2x_chevron";
  UiIconName2["Arrows_UpArrow"] = "Arrows/up_arrow";
  UiIconName2["Arrows_Upload"] = "Arrows/upload";
  UiIconName2["Arrows_UpperCircle"] = "Arrows/upper_circle";
  UiIconName2["Arrows_UpperLeftArrow"] = "Arrows/upper_left_arrow";
  UiIconName2["Arrows_UpperRightArrow"] = "Arrows/upper_right_arrow";
  UiIconName2["Arrows_VerticalAlignCenter"] = "Arrows/vertical_align_center";
  UiIconName2["Arrows_VerticalResize"] = "Arrows/vertical_resize";
  UiIconName2["Arrows_VerticalResizeTable"] = "Arrows/vertical_resize_table";
  UiIconName2["Brands_Android"] = "Brands/android";
  UiIconName2["Brands_AndroidSolid"] = "Brands/android_solid";
  UiIconName2["Brands_Apple"] = "Brands/apple";
  UiIconName2["Brands_AppleSolid"] = "Brands/apple_solid";
  UiIconName2["Brands_Chat"] = "Brands/chat";
  UiIconName2["Brands_Intercom"] = "Brands/intercom";
  UiIconName2["Brands_IntercomSolid"] = "Brands/intercom_solid";
  UiIconName2["Brands_Whatsapp"] = "Brands/whatsapp";
  UiIconName2["Brands_Youtube"] = "Brands/youtube";
  UiIconName2["Business_Aim"] = "Business/aim";
  UiIconName2["Business_Bank"] = "Business/bank";
  UiIconName2["Business_BarGraph"] = "Business/bar_graph";
  UiIconName2["Business_Bill"] = "Business/bill";
  UiIconName2["Business_Calculation"] = "Business/calculation";
  UiIconName2["Business_Calendar"] = "Business/calendar";
  UiIconName2["Business_CashBundle"] = "Business/cash_bundle";
  UiIconName2["Business_CreditCard"] = "Business/credit_card";
  UiIconName2["Business_Dollar"] = "Business/dollar";
  UiIconName2["Business_DollarCoin"] = "Business/dollar_coin";
  UiIconName2["Business_Euro"] = "Business/euro";
  UiIconName2["Business_EuroCoin"] = "Business/euro_coin";
  UiIconName2["Business_Formula"] = "Business/formula";
  UiIconName2["Business_Goal"] = "Business/goal";
  UiIconName2["Business_Graph"] = "Business/graph";
  UiIconName2["Business_GrowthGraph"] = "Business/growth_graph";
  UiIconName2["Business_LightBulb"] = "Business/light_bulb";
  UiIconName2["Business_ListFormat"] = "Business/list_format";
  UiIconName2["Business_Money"] = "Business/money";
  UiIconName2["Business_OfficeBag"] = "Business/office_bag";
  UiIconName2["Business_Percentage"] = "Business/percentage";
  UiIconName2["Business_PieChart"] = "Business/pie_chart";
  UiIconName2["Business_Pound"] = "Business/pound";
  UiIconName2["Business_PoundCoin"] = "Business/pound_coin";
  UiIconName2["Business_PresentationBoard"] = "Business/presentation_board";
  UiIconName2["Business_Puzzle"] = "Business/puzzle";
  UiIconName2["Business_ShowChart"] = "Business/show_chart";
  UiIconName2["Business_Sitemap"] = "Business/sitemap";
  UiIconName2["Business_Target"] = "Business/target";
  UiIconName2["Business_Withdrawal"] = "Business/withdrawal";
  UiIconName2["Business_Yen"] = "Business/yen";
  UiIconName2["Business_YenCoin"] = "Business/yen_coin";
  UiIconName2["Change"] = "Change";
  UiIconName2["Chat"] = "Chat";
  UiIconName2["Chat_AddChat"] = "Chat/add_chat";
  UiIconName2["Chat_ApproveChat"] = "Chat/approve_chat";
  UiIconName2["Chat_BlockChat"] = "Chat/block_chat";
  UiIconName2["Chat_Chat"] = "Chat/chat";
  UiIconName2["Chat_ChatBubble"] = "Chat/chat_bubble";
  UiIconName2["Chat_ChatInfo"] = "Chat/chat_info";
  UiIconName2["Chat_ChatSignal"] = "Chat/chat_signal";
  UiIconName2["Chat_ChatSupport"] = "Chat/chat_support";
  UiIconName2["Chat_DownloadChat"] = "Chat/download_chat";
  UiIconName2["Chat_EditChat"] = "Chat/edit_chat";
  UiIconName2["Chat_Fill"] = "Chat/fill";
  UiIconName2["Chat_MedicalChat"] = "Chat/medical_chat";
  UiIconName2["Chat_PrivateChat"] = "Chat/private_chat";
  UiIconName2["Chat_ReloadChat"] = "Chat/reload_chat";
  UiIconName2["Chat_SearchMessage"] = "Chat/search_message";
  UiIconName2["Chat_SecureChat"] = "Chat/secure_chat";
  UiIconName2["Chat_ShareChat"] = "Chat/share_chat";
  UiIconName2["Chat_Typing"] = "Chat/typing";
  UiIconName2["Chat_UploadChatBubble"] = "Chat/upload_chat_bubble";
  UiIconName2["CheckboxDeselected"] = "Checkbox_Deselected";
  UiIconName2["CheckboxDisabled"] = "Checkbox_Disabled";
  UiIconName2["CheckboxDisabledCheck"] = "Checkbox_Disabled_check";
  UiIconName2["CheckboxIndeterminate"] = "Checkbox_Indeterminate";
  UiIconName2["CheckboxMobileDeselected"] = "Checkbox_Mobile_Deselected";
  UiIconName2["CheckboxMobileIndeterminate"] = "Checkbox_Mobile_Indeterminate";
  UiIconName2["CheckboxMobileMultiselect"] = "Checkbox_Mobile_Multiselect";
  UiIconName2["CheckboxMobileMultiselect2"] = "Checkbox_Mobile_Multiselect_2";
  UiIconName2["CheckboxMobileSelected"] = "Checkbox_Mobile_Selected";
  UiIconName2["CheckboxSelected"] = "Checkbox_Selected";
  UiIconName2["ChevronDown"] = "Chevron_down";
  UiIconName2["ChevronDownFill"] = "Chevron_down_Fill";
  UiIconName2["ChevronLeft"] = "Chevron_left";
  UiIconName2["ChevronLeftFill"] = "Chevron_left_Fill";
  UiIconName2["ChevronRight"] = "Chevron_right";
  UiIconName2["ChevronRightFill"] = "Chevron_right_Fill";
  UiIconName2["ChevronUp"] = "Chevron_up";
  UiIconName2["ChevronUpFill"] = "Chevron_up_Fill";
  UiIconName2["CloudAndWeb_ApprovedCloud"] = "Cloud_and_Web/approved_cloud";
  UiIconName2["CloudAndWeb_BlockCloud"] = "Cloud_and_Web/block_cloud";
  UiIconName2["CloudAndWeb_BookmarkCloud"] = "Cloud_and_Web/bookmark_cloud";
  UiIconName2["CloudAndWeb_CancelCloud"] = "Cloud_and_Web/cancel_cloud";
  UiIconName2["CloudAndWeb_CloudConnection"] = "Cloud_and_Web/cloud_connection";
  UiIconName2["CloudAndWeb_CloudInfo"] = "Cloud_and_Web/cloud_info";
  UiIconName2["CloudAndWeb_CloudSignal"] = "Cloud_and_Web/cloud_signal";
  UiIconName2["CloudAndWeb_DataStorage"] = "Cloud_and_Web/data_storage";
  UiIconName2["CloudAndWeb_Database"] = "Cloud_and_Web/database";
  UiIconName2["CloudAndWeb_Download"] = "Cloud_and_Web/download";
  UiIconName2["CloudAndWeb_Help"] = "Cloud_and_Web/help";
  UiIconName2["CloudAndWeb_InfoCloud"] = "Cloud_and_Web/info_cloud";
  UiIconName2["CloudAndWeb_Loadweb"] = "Cloud_and_Web/loadweb";
  UiIconName2["CloudAndWeb_LockCloud"] = "Cloud_and_Web/lock_cloud";
  UiIconName2["CloudAndWeb_NoConnection"] = "Cloud_and_Web/no_connection";
  UiIconName2["CloudAndWeb_RefreshCloud"] = "Cloud_and_Web/refresh_cloud";
  UiIconName2["CloudAndWeb_Server"] = "Cloud_and_Web/server";
  UiIconName2["CloudAndWeb_ServerConnection"] = "Cloud_and_Web/server_connection";
  UiIconName2["CloudAndWeb_ShareCloud"] = "Cloud_and_Web/share_cloud";
  UiIconName2["CloudAndWeb_Shield"] = "Cloud_and_Web/shield";
  UiIconName2["CloudAndWeb_UnlockCloud"] = "Cloud_and_Web/unlock_cloud";
  UiIconName2["CloudAndWeb_Upload"] = "Cloud_and_Web/upload";
  UiIconName2["CloudAndWeb_Web"] = "Cloud_and_Web/web";
  UiIconName2["CloudAndWeb_WebLayout1"] = "Cloud_and_Web/web_layout_1";
  UiIconName2["CloudAndWeb_WebLayout2"] = "Cloud_and_Web/web_layout_2";
  UiIconName2["CloudAndWeb_WebLayout3"] = "Cloud_and_Web/web_layout_3";
  UiIconName2["CloudAndWeb_WebLayout4"] = "Cloud_and_Web/web_layout_4";
  UiIconName2["CloudAndWeb_WebLayout5"] = "Cloud_and_Web/web_layout_5";
  UiIconName2["CloudAndWeb_WebLayout6"] = "Cloud_and_Web/web_layout_6";
  UiIconName2["CloudAndWeb_WebLayout7"] = "Cloud_and_Web/web_layout_7";
  UiIconName2["CloudAndWeb_WebLayout8"] = "Cloud_and_Web/web_layout_8";
  UiIconName2["CloudAndWeb_WebLayout9"] = "Cloud_and_Web/web_layout_9";
  UiIconName2["CloudAndWeb_WindowRestore"] = "Cloud_and_Web/window_restore";
  UiIconName2["Communication_Call"] = "Communication/call";
  UiIconName2["Communication_CallActive"] = "Communication/call_active";
  UiIconName2["Communication_EditMail"] = "Communication/edit_mail";
  UiIconName2["Communication_Envelope"] = "Communication/envelope";
  UiIconName2["Communication_HelpMail"] = "Communication/help_mail";
  UiIconName2["Communication_Message"] = "Communication/message";
  UiIconName2["Communication_OpenMail"] = "Communication/open_mail";
  UiIconName2["Content_Bold"] = "Content/bold";
  UiIconName2["Content_BorderStyle"] = "Content/border_style";
  UiIconName2["Content_BottomBorder"] = "Content/bottom_border";
  UiIconName2["Content_Dialpad"] = "Content/dialpad";
  UiIconName2["Content_DocumentLayout"] = "Content/document_layout";
  UiIconName2["Content_ExpandBottom"] = "Content/expand_bottom";
  UiIconName2["Content_ExpandTop"] = "Content/expand_top";
  UiIconName2["Content_FormatTextDirectionLeftToRight"] = "Content/format_text_direction_left_to_right";
  UiIconName2["Content_FormatTextDirectionRightToLeft"] = "Content/format_text_direction_right_to_left";
  UiIconName2["Content_Functions"] = "Content/functions";
  UiIconName2["Content_HorizontalBorder"] = "Content/horizontal_border";
  UiIconName2["Content_InsideBorder"] = "Content/inside_border";
  UiIconName2["Content_Italic"] = "Content/italic";
  UiIconName2["Content_LeftBorder"] = "Content/left_border";
  UiIconName2["Content_LeftIndent"] = "Content/left_indent";
  UiIconName2["Content_ListUiAlt"] = "Content/list-ui-alt";
  UiIconName2["Content_ListFormat"] = "Content/list_format";
  UiIconName2["Content_NoneBorder"] = "Content/none_border";
  UiIconName2["Content_RightBorder"] = "Content/right_border";
  UiIconName2["Content_RightIndent"] = "Content/right_indent";
  UiIconName2["Content_Text"] = "Content/text";
  UiIconName2["Content_TextFields"] = "Content/text_fields";
  UiIconName2["Content_Th"] = "Content/th";
  UiIconName2["Content_TopBorder"] = "Content/top_border";
  UiIconName2["Content_Underline"] = "Content/underline";
  UiIconName2["Content_VerticalBorder"] = "Content/vertical_border";
  UiIconName2["Content_WrapText"] = "Content/wrap_text";
  UiIconName2["DesignTools_AssortmentMatrix"] = "Design_tools/Assortment_matrix";
  UiIconName2["DesignTools_Border"] = "Design_tools/border";
  UiIconName2["DesignTools_BringObjectToBottom"] = "Design_tools/bring_object_to_bottom";
  UiIconName2["DesignTools_Brush"] = "Design_tools/brush";
  UiIconName2["DesignTools_CircleLayer"] = "Design_tools/circle_layer";
  UiIconName2["DesignTools_ColorPalette"] = "Design_tools/color_palette";
  UiIconName2["DesignTools_Compress2"] = "Design_tools/compress_2";
  UiIconName2["DesignTools_Crop"] = "Design_tools/crop";
  UiIconName2["DesignTools_Exclude"] = "Design_tools/exclude";
  UiIconName2["DesignTools_Eye"] = "Design_tools/eye";
  UiIconName2["DesignTools_Grid4"] = "Design_tools/grid_4";
  UiIconName2["DesignTools_Grid6"] = "Design_tools/grid_6";
  UiIconName2["DesignTools_GridHorizon"] = "Design_tools/grid_horizon";
  UiIconName2["DesignTools_GridLayout"] = "Design_tools/grid_layout";
  UiIconName2["DesignTools_GridOff"] = "Design_tools/grid_off";
  UiIconName2["DesignTools_HorizontalAlignCenter"] = "Design_tools/horizontal_align_center";
  UiIconName2["DesignTools_HorizontalAlignLeft"] = "Design_tools/horizontal_align_left";
  UiIconName2["DesignTools_HorizontalAlignRight"] = "Design_tools/horizontal_align_right";
  UiIconName2["DesignTools_HorizontalDistributeCenter"] = "Design_tools/horizontal_distribute_center";
  UiIconName2["DesignTools_HorizontalDistributeLeft"] = "Design_tools/horizontal_distribute_left";
  UiIconName2["DesignTools_HorizontalDistributeRight"] = "Design_tools/horizontal_distribute_right";
  UiIconName2["DesignTools_HorizontalFlip"] = "Design_tools/horizontal_flip";
  UiIconName2["DesignTools_ImageResize"] = "Design_tools/image_resize";
  UiIconName2["DesignTools_Intersect"] = "Design_tools/intersect";
  UiIconName2["DesignTools_Layers"] = "Design_tools/layers";
  UiIconName2["DesignTools_Line"] = "Design_tools/line";
  UiIconName2["DesignTools_LineSpacing"] = "Design_tools/line_spacing";
  UiIconName2["DesignTools_MinusPath"] = "Design_tools/minus_path";
  UiIconName2["DesignTools_ObjectGroup"] = "Design_tools/object_group";
  UiIconName2["DesignTools_ObjectUngroup"] = "Design_tools/object_ungroup";
  UiIconName2["DesignTools_OutBorder"] = "Design_tools/out_border";
  UiIconName2["DesignTools_Panorama"] = "Design_tools/panorama";
  UiIconName2["DesignTools_Repeat"] = "Design_tools/repeat";
  UiIconName2["DesignTools_Ruler"] = "Design_tools/ruler";
  UiIconName2["DesignTools_Shrink"] = "Design_tools/shrink";
  UiIconName2["DesignTools_ShrinkLines"] = "Design_tools/shrink_lines";
  UiIconName2["DesignTools_Spin"] = "Design_tools/spin";
  UiIconName2["DesignTools_TransformTool"] = "Design_tools/transform_tool";
  UiIconName2["DesignTools_TransformToolLocked"] = "Design_tools/transform_tool_locked";
  UiIconName2["DesignTools_Unite"] = "Design_tools/unite";
  UiIconName2["DesignTools_VerticalAlignBottom"] = "Design_tools/vertical_align_bottom";
  UiIconName2["DesignTools_VerticalAlignCenter"] = "Design_tools/vertical_align_center";
  UiIconName2["DesignTools_VerticalAlignTop"] = "Design_tools/vertical_align_top";
  UiIconName2["DesignTools_VerticalDistributeBottom"] = "Design_tools/vertical_distribute_bottom";
  UiIconName2["DesignTools_VerticalDistributeCenter"] = "Design_tools/vertical_distribute_center";
  UiIconName2["DesignTools_VerticalDistributeTop"] = "Design_tools/vertical_distribute_top";
  UiIconName2["DesignTools_VerticalFlip"] = "Design_tools/vertical_flip";
  UiIconName2["DesignTools_VerticalPanorama"] = "Design_tools/vertical_panorama";
  UiIconName2["Device_ComputerMouse"] = "Device/computer_mouse";
  UiIconName2["Device_HardDisk"] = "Device/hard_disk";
  UiIconName2["Device_Mobile"] = "Device/mobile";
  UiIconName2["Device_Modem"] = "Device/modem";
  UiIconName2["Device_Monitor"] = "Device/monitor";
  UiIconName2["Device_Printer"] = "Device/printer";
  UiIconName2["Education_Award"] = "Education/award";
  UiIconName2["Education_Badge"] = "Education/badge";
  UiIconName2["Education_Book"] = "Education/book";
  UiIconName2["Education_BookmarkInBook"] = "Education/bookmark_in_book";
  UiIconName2["Education_Brain"] = "Education/brain";
  UiIconName2["Education_Library"] = "Education/library";
  UiIconName2["Education_Medal"] = "Education/medal";
  UiIconName2["Education_Mortarboard"] = "Education/mortarboard";
  UiIconName2["Education_Notes"] = "Education/notes";
  UiIconName2["Education_OpenBook"] = "Education/open_book";
  UiIconName2["Education_PlayPresentation"] = "Education/play_presentation";
  UiIconName2["Education_Presentation"] = "Education/presentation";
  UiIconName2["FileAndFolder_AddDocument"] = "File_and_Folder/add_document";
  UiIconName2["FileAndFolder_AddFolder"] = "File_and_Folder/add_folder";
  UiIconName2["FileAndFolder_AddNewFile"] = "File_and_Folder/add_new_file";
  UiIconName2["FileAndFolder_ApproveFile"] = "File_and_Folder/approve_file";
  UiIconName2["FileAndFolder_ApproveFolder"] = "File_and_Folder/approve_folder";
  UiIconName2["FileAndFolder_BlockFile"] = "File_and_Folder/block_file";
  UiIconName2["FileAndFolder_BookmarkDocument"] = "File_and_Folder/bookmark_document";
  UiIconName2["FileAndFolder_Books"] = "File_and_Folder/books";
  UiIconName2["FileAndFolder_Checklist"] = "File_and_Folder/checklist";
  UiIconName2["FileAndFolder_Clipboard"] = "File_and_Folder/clipboard";
  UiIconName2["FileAndFolder_ClipboardClean"] = "File_and_Folder/clipboard_clean";
  UiIconName2["FileAndFolder_DeleteFile"] = "File_and_Folder/delete_file";
  UiIconName2["FileAndFolder_DeleteFolder"] = "File_and_Folder/delete_folder";
  UiIconName2["FileAndFolder_Document"] = "File_and_Folder/document";
  UiIconName2["FileAndFolder_DocumentClean"] = "File_and_Folder/document_clean";
  UiIconName2["FileAndFolder_DocumentCopy"] = "File_and_Folder/document_copy";
  UiIconName2["FileAndFolder_DocumentInfo"] = "File_and_Folder/document_info";
  UiIconName2["FileAndFolder_DocumentInfoClean"] = "File_and_Folder/document_info_clean";
  UiIconName2["FileAndFolder_DownloadFile"] = "File_and_Folder/download_file";
  UiIconName2["FileAndFolder_DownloadFile2"] = "File_and_Folder/download_file_2";
  UiIconName2["FileAndFolder_DownloadFolder"] = "File_and_Folder/download_folder";
  UiIconName2["FileAndFolder_EditFile"] = "File_and_Folder/edit_file";
  UiIconName2["FileAndFolder_FavoriteFile"] = "File_and_Folder/favorite_file";
  UiIconName2["FileAndFolder_FavoriteFolder"] = "File_and_Folder/favorite_folder";
  UiIconName2["FileAndFolder_Folder"] = "File_and_Folder/folder";
  UiIconName2["FileAndFolder_FolderInfo"] = "File_and_Folder/folder_info";
  UiIconName2["FileAndFolder_HelpFile"] = "File_and_Folder/help_file";
  UiIconName2["FileAndFolder_HelpFolder"] = "File_and_Folder/help_folder";
  UiIconName2["FileAndFolder_LockFile"] = "File_and_Folder/lock_file";
  UiIconName2["FileAndFolder_LockFolder"] = "File_and_Folder/lock_folder";
  UiIconName2["FileAndFolder_MedicalFile"] = "File_and_Folder/medical_file";
  UiIconName2["FileAndFolder_MedicalFolder"] = "File_and_Folder/medical_folder";
  UiIconName2["FileAndFolder_ProtectedFile"] = "File_and_Folder/protected_file";
  UiIconName2["FileAndFolder_ReloadFile"] = "File_and_Folder/reload_file";
  UiIconName2["FileAndFolder_RemoveDocument"] = "File_and_Folder/remove_document";
  UiIconName2["FileAndFolder_RemoveFolder"] = "File_and_Folder/remove_folder";
  UiIconName2["FileAndFolder_SearchFile"] = "File_and_Folder/search_file";
  UiIconName2["FileAndFolder_ShareFile"] = "File_and_Folder/share_file";
  UiIconName2["FileAndFolder_UploadFile"] = "File_and_Folder/upload_file";
  UiIconName2["FileAndFolder_UploadFolder"] = "File_and_Folder/upload_folder";
  UiIconName2["IQTools_Alcohol"] = "IQ_tools/alcohol";
  UiIconName2["IQTools_Alcoholdemo"] = "IQ_tools/alcoholdemo";
  UiIconName2["IQTools_Antifraud"] = "IQ_tools/antifraud";
  UiIconName2["IQTools_Antifrauddemo"] = "IQ_tools/antifrauddemo";
  UiIconName2["IQTools_Beer"] = "IQ_tools/beer";
  UiIconName2["IQTools_Beerdemo"] = "IQ_tools/beerdemo";
  UiIconName2["IQTools_Dairy"] = "IQ_tools/dairy";
  UiIconName2["IQTools_Dairydemo"] = "IQ_tools/dairydemo";
  UiIconName2["IQTools_Grocery"] = "IQ_tools/grocery";
  UiIconName2["IQTools_Grocerydemo"] = "IQ_tools/grocerydemo";
  UiIconName2["IQTools_Hygiene"] = "IQ_tools/hygiene";
  UiIconName2["IQTools_Hygienedemo"] = "IQ_tools/hygienedemo";
  UiIconName2["IQTools_Petcare"] = "IQ_tools/petcare";
  UiIconName2["IQTools_Petcaredemo"] = "IQ_tools/petcaredemo";
  UiIconName2["IQTools_Pharma"] = "IQ_tools/pharma";
  UiIconName2["IQTools_Pharmademo"] = "IQ_tools/pharmademo";
  UiIconName2["IQTools_Posm"] = "IQ_tools/posm";
  UiIconName2["IQTools_Posmdemo"] = "IQ_tools/posmdemo";
  UiIconName2["IQTools_Price"] = "IQ_tools/price";
  UiIconName2["IQTools_Pricedemo"] = "IQ_tools/pricedemo";
  UiIconName2["IQTools_Shelf"] = "IQ_tools/shelf";
  UiIconName2["IQTools_Shelfdemo"] = "IQ_tools/shelfdemo";
  UiIconName2["IQTools_Sweets"] = "IQ_tools/sweets";
  UiIconName2["IQTools_Sweetsdemo"] = "IQ_tools/sweetsdemo";
  UiIconName2["IQTools_Tobacco"] = "IQ_tools/tobacco";
  UiIconName2["IQTools_Tobaccodemo"] = "IQ_tools/tobaccodemo";
  UiIconName2["IQtools_ClarifyingNetwork"] = "IQtools/clarifying_network";
  UiIconName2["IQtools_PriceClarifications"] = "IQtools/price_clarifications";
  UiIconName2["LocationAndMap_AddLocation"] = "Location_and_Map/add_location";
  UiIconName2["LocationAndMap_Checklocation"] = "Location_and_Map/checklocation";
  UiIconName2["LocationAndMap_Checklocationfill"] = "Location_and_Map/checklocationfill";
  UiIconName2["LocationAndMap_DirectionBoard"] = "Location_and_Map/direction_board";
  UiIconName2["LocationAndMap_DirectionTool"] = "Location_and_Map/direction_tool";
  UiIconName2["LocationAndMap_EditLocation"] = "Location_and_Map/edit_location";
  UiIconName2["LocationAndMap_HelpLocation"] = "Location_and_Map/help_location";
  UiIconName2["LocationAndMap_Location"] = "Location_and_Map/location";
  UiIconName2["LocationAndMap_LocationError"] = "Location_and_Map/location_error";
  UiIconName2["LocationAndMap_LocationInfo"] = "Location_and_Map/location_info";
  UiIconName2["LocationAndMap_LocationPin"] = "Location_and_Map/location_pin";
  UiIconName2["LocationAndMap_Map"] = "Location_and_Map/map";
  UiIconName2["LocationAndMap_Navigation"] = "Location_and_Map/navigation";
  UiIconName2["LocationAndMap_RemoveLocation"] = "Location_and_Map/remove_location";
  UiIconName2["LocationAndMap_SecureLocation"] = "Location_and_Map/secure_location";
  UiIconName2["LocationAndMap_Signboard"] = "Location_and_Map/signboard";
  UiIconName2["Multimedia_PhotoError"] = "Multimedia/Photo_error";
  UiIconName2["Multimedia_AddImage"] = "Multimedia/add_image";
  UiIconName2["Multimedia_AddPhoto"] = "Multimedia/add_photo";
  UiIconName2["Multimedia_ApproveImage"] = "Multimedia/approve_image";
  UiIconName2["Multimedia_Camera"] = "Multimedia/camera";
  UiIconName2["Multimedia_CameraChange"] = "Multimedia/camera_change";
  UiIconName2["Multimedia_CorruptedImage"] = "Multimedia/corrupted_image";
  UiIconName2["Multimedia_Csv"] = "Multimedia/csv";
  UiIconName2["Multimedia_DeletePhoto"] = "Multimedia/delete_photo";
  UiIconName2["Multimedia_DownloadImage"] = "Multimedia/download_image";
  UiIconName2["Multimedia_Equalizer"] = "Multimedia/equalizer";
  UiIconName2["Multimedia_Image"] = "Multimedia/image";
  UiIconName2["Multimedia_ImageInfo"] = "Multimedia/image_info";
  UiIconName2["Multimedia_ImageReload"] = "Multimedia/image_reload";
  UiIconName2["Multimedia_LockGallary"] = "Multimedia/lock_gallary";
  UiIconName2["Multimedia_MultipleImage"] = "Multimedia/multiple_image";
  UiIconName2["Multimedia_Mute"] = "Multimedia/mute";
  UiIconName2["Multimedia_NoFlash"] = "Multimedia/no_flash";
  UiIconName2["Multimedia_NotAllowPhoto"] = "Multimedia/not_allow_photo";
  UiIconName2["Multimedia_Pause"] = "Multimedia/pause";
  UiIconName2["Multimedia_PauseCircle"] = "Multimedia/pause_circle";
  UiIconName2["Multimedia_PauseFill"] = "Multimedia/pause_fill";
  UiIconName2["Multimedia_PhotoEditor"] = "Multimedia/photo_editor";
  UiIconName2["Multimedia_Play2"] = "Multimedia/play_2";
  UiIconName2["Multimedia_PlayFill"] = "Multimedia/play_fill";
  UiIconName2["Multimedia_ProtectedImage"] = "Multimedia/protected_image";
  UiIconName2["Multimedia_RemoveImage"] = "Multimedia/remove_image";
  UiIconName2["Multimedia_RssInterface"] = "Multimedia/rss_interface";
  UiIconName2["Multimedia_SearchImage"] = "Multimedia/search_image";
  UiIconName2["Multimedia_SharePicture"] = "Multimedia/share_picture";
  UiIconName2["Multimedia_StopFill"] = "Multimedia/stop_fill";
  UiIconName2["Multimedia_UploadImage"] = "Multimedia/upload_image";
  UiIconName2["Multimedia_VideoCamera"] = "Multimedia/video_camera";
  UiIconName2["Multimedia_Xslx"] = "Multimedia/xslx";
  UiIconName2["PhotoErrors_AngleError"] = "Photo_errors/_angle_error";
  UiIconName2["PhotoErrors_BlurryPhoto"] = "Photo_errors/_blurry_photo";
  UiIconName2["PhotoErrors_Duplicate"] = "Photo_errors/_duplicate";
  UiIconName2["PhotoErrors_FarAway"] = "Photo_errors/_far_away";
  UiIconName2["PhotoErrors_GeoError"] = "Photo_errors/_geo_error";
  UiIconName2["PhotoErrors_Near"] = "Photo_errors/_near";
  UiIconName2["PhotoErrors_Screenshot"] = "Photo_errors/_screenshot";
  UiIconName2["PhotoErrors_StitchingError"] = "Photo_errors/stitching_error";
  UiIconName2["PhotoStitching"] = "Photo_stitching";
  UiIconName2["Photography_Exposure"] = "Photography/exposure";
  UiIconName2["Photography_Eye"] = "Photography/eye";
  UiIconName2["Photography_Focus"] = "Photography/focus";
  UiIconName2["Photography_Realogramm"] = "Photography/realogramm";
  UiIconName2["RadioButtonMobileIOSIndeterminate"] = "Radio_Button_Mobile_IOS_Indeterminate";
  UiIconName2["RadioButtonMobileIOSOff"] = "Radio_Button_Mobile_IOS_Off";
  UiIconName2["RadioButtonMobileIOSOn"] = "Radio_Button_Mobile_IOS_On";
  UiIconName2["RadioButtonMobileOff"] = "Radio_Button_Mobile_Off";
  UiIconName2["RadioButtonMobileOn"] = "Radio_Button_Mobile_On";
  UiIconName2["RadioButtonOff"] = "Radio_Button_Off";
  UiIconName2["RadioButtonOn"] = "Radio_Button_On";
  UiIconName2["Report_SOS"] = "Report/SOS";
  UiIconName2["SFA_Group"] = "SFA/group";
  UiIconName2["SFA_List"] = "SFA/list";
  UiIconName2["SFA_Tasks"] = "SFA/tasks";
  UiIconName2["SFA_Templates"] = "SFA/templates";
  UiIconName2["Security_KeyholeCircle"] = "Security/keyhole_circle";
  UiIconName2["Security_KeyholeSquare"] = "Security/keyhole_square";
  UiIconName2["Security_KeyholeSquareRound"] = "Security/keyhole_square_round";
  UiIconName2["Security_Lock"] = "Security/lock";
  UiIconName2["Security_LockKey"] = "Security/lock_key";
  UiIconName2["Security_LockLayout"] = "Security/lock_layout";
  UiIconName2["Security_LockOpen"] = "Security/lock_open";
  UiIconName2["Security_Shield"] = "Security/shield";
  UiIconName2["Security_ShieldCheck"] = "Security/shield_check";
  UiIconName2["Security_ShieldExclamation"] = "Security/shield_exclamation";
  UiIconName2["Security_ShieldQuestion"] = "Security/shield_question";
  UiIconName2["Security_ShieldSlash"] = "Security/shield_slash";
  UiIconName2["Security_Unlock"] = "Security/unlock";
  UiIconName2["Security_UnlockKey"] = "Security/unlock_key";
  UiIconName2["Shapes_Circle"] = "Shapes/circle";
  UiIconName2["Shapes_CircleFill"] = "Shapes/circle_fill";
  UiIconName2["Shapes_CircleSmall"] = "Shapes/circle_small";
  UiIconName2["Shapes_Heart"] = "Shapes/heart";
  UiIconName2["Shapes_Hexagon"] = "Shapes/hexagon";
  UiIconName2["Shapes_Square"] = "Shapes/square";
  UiIconName2["Shapes_SquareRound"] = "Shapes/square_round";
  UiIconName2["Shapes_StarShape"] = "Shapes/star_shape";
  UiIconName2["Shapes_Tagline"] = "Shapes/tagline";
  UiIconName2["Shapes_Triangle"] = "Shapes/triangle";
  UiIconName2["Shopping_Archive"] = "Shopping/archive";
  UiIconName2["Shopping_Basket"] = "Shopping/basket";
  UiIconName2["Shopping_Cart"] = "Shopping/cart";
  UiIconName2["Shopping_Gift"] = "Shopping/gift";
  UiIconName2["Shopping_KidsStore"] = "Shopping/kids_store";
  UiIconName2["Shopping_Label"] = "Shopping/label";
  UiIconName2["Shopping_Shop"] = "Shopping/shop";
  UiIconName2["Shopping_ShoppingBag"] = "Shopping/shopping_bag";
  UiIconName2["Shopping_Tag"] = "Shopping/tag";
  UiIconName2["SignAndSymbol_Block"] = "Sign_and_Symbol/block";
  UiIconName2["Sku_Barcode"] = "Sku/barcode";
  UiIconName2["Sku_Category"] = "Sku/category";
  UiIconName2["Sku_LinkProject"] = "Sku/link_project";
  UiIconName2["Sku_Neural"] = "Sku/neural";
  UiIconName2["Sku_Products"] = "Sku/products";
  UiIconName2["Solid_Ailet"] = "Solid/Ailet";
  UiIconName2["Solid_Home"] = "Solid/Home";
  UiIconName2["Solid_PlActivated"] = "Solid/Pl_activated";
  UiIconName2["Solid_PlDefault"] = "Solid/Pl_default";
  UiIconName2["Solid_Search"] = "Solid/Search";
  UiIconName2["Solid_Settings"] = "Solid/Settings";
  UiIconName2["Solid_Analysis"] = "Solid/analysis";
  UiIconName2["Solid_Analytics"] = "Solid/analytics";
  UiIconName2["Solid_Apps"] = "Solid/apps";
  UiIconName2["Solid_ArrowCircleDown"] = "Solid/arrow_circle_down";
  UiIconName2["Solid_ArrowCircleLeft"] = "Solid/arrow_circle_left";
  UiIconName2["Solid_ArrowCircleRight"] = "Solid/arrow_circle_right";
  UiIconName2["Solid_ArrowCircleUp"] = "Solid/arrow_circle_up";
  UiIconName2["Solid_Bars"] = "Solid/bars";
  UiIconName2["Solid_BatteryBolt"] = "Solid/battery_bolt";
  UiIconName2["Solid_BatteryEmpty"] = "Solid/battery_empty";
  UiIconName2["Solid_Bookmark"] = "Solid/bookmark";
  UiIconName2["Solid_Chart"] = "Solid/chart";
  UiIconName2["Solid_ChartPie"] = "Solid/chart_pie";
  UiIconName2["Solid_CircleIndeterminate"] = "Solid/circle_Indeterminate";
  UiIconName2["Solid_CircleApprove"] = "Solid/circle_approve";
  UiIconName2["Solid_Dialpad"] = "Solid/dialpad";
  UiIconName2["Solid_Ellipse"] = "Solid/ellipse";
  UiIconName2["Solid_GraphBar"] = "Solid/graph_bar";
  UiIconName2["Solid_HorizontalAlignLeft"] = "Solid/horizontal_align_left";
  UiIconName2["Solid_Info"] = "Solid/info";
  UiIconName2["Solid_Lock"] = "Solid/lock";
  UiIconName2["Solid_Puzzle"] = "Solid/puzzle";
  UiIconName2["Solid_Ruler"] = "Solid/ruler";
  UiIconName2["Solid_RulerCombined"] = "Solid/ruler_combined";
  UiIconName2["Solid_SignalAlt3"] = "Solid/signal_alt_3";
  UiIconName2["Solid_Star"] = "Solid/star";
  UiIconName2["Solid_StarHalfAlt"] = "Solid/star_half_alt";
  UiIconName2["Solid_TimesCircle"] = "Solid/times_circle";
  UiIconName2["Solid_Unlock"] = "Solid/unlock";
  UiIconName2["Solid_Warning"] = "Solid/warning";
  UiIconName2["SwitchAndroid"] = "Switch_Android_";
  UiIconName2["SwitchAndroidActivity"] = "Switch_Android_Activity";
  UiIconName2["SwitchOff"] = "Switch_Off";
  UiIconName2["SwitchOn"] = "Switch_On";
  UiIconName2["SwitchIOSOff"] = "Switch_iOS_Off";
  UiIconName2["SwitchIOSOn"] = "Switch_iOS_On";
  UiIconName2["Table_TClean"] = "Table/T_clean";
  UiIconName2["Table_TFilters"] = "Table/T_filters";
  UiIconName2["Table_TSettings"] = "Table/T_settings";
  UiIconName2["Time_Before"] = "Time/Before";
  UiIconName2["Time_After"] = "Time/after";
  UiIconName2["Time_Clock"] = "Time/clock";
  UiIconName2["Time_ClockEight"] = "Time/clock_eight";
  UiIconName2["Time_ClockFive"] = "Time/clock_five";
  UiIconName2["Time_ClockNine"] = "Time/clock_nine";
  UiIconName2["Time_ClockSeven"] = "Time/clock_seven";
  UiIconName2["Time_ClockTen"] = "Time/clock_ten";
  UiIconName2["Time_ClockThree"] = "Time/clock_three";
  UiIconName2["Time_ClockTwo"] = "Time/clock_two";
  UiIconName2["Time_Stopwatch"] = "Time/stopwatch";
  UiIconName2["Time_Watch"] = "Time/watch";
  UiIconName2["Transport_Car"] = "Transport/car";
  UiIconName2["Transport_SchoolBus"] = "Transport/school_bus";
  UiIconName2["Transport_Walk"] = "Transport/walk";
  UiIconName2["UserInterface_360Rotate"] = "User_Interface/360_Rotate";
  UiIconName2["UserInterface_AddNew"] = "User_Interface/Add_New";
  UiIconName2["UserInterface_Angle"] = "User_Interface/Angle";
  UiIconName2["UserInterface_Attach"] = "User_Interface/Attach";
  UiIconName2["UserInterface_AutoFlash"] = "User_Interface/Auto_Flash";
  UiIconName2["UserInterface_AvoidSynchronize"] = "User_Interface/Avoid_Synchronize";
  UiIconName2["UserInterface_Back"] = "User_Interface/Back";
  UiIconName2["UserInterface_Backspace"] = "User_Interface/Backspace";
  UiIconName2["UserInterface_Backup"] = "User_Interface/Backup";
  UiIconName2["UserInterface_Battery"] = "User_Interface/Battery";
  UiIconName2["UserInterface_BatteryCharging"] = "User_Interface/Battery_Charging";
  UiIconName2["UserInterface_Bell"] = "User_Interface/Bell";
  UiIconName2["UserInterface_BlockLayers"] = "User_Interface/Block_Layers";
  UiIconName2["UserInterface_Bluetooth"] = "User_Interface/Bluetooth";
  UiIconName2["UserInterface_Bolt"] = "User_Interface/Bolt";
  UiIconName2["UserInterface_Box"] = "User_Interface/Box";
  UiIconName2["UserInterface_BrokenChain"] = "User_Interface/Broken_Chain";
  UiIconName2["UserInterface_Calculation"] = "User_Interface/Calculation";
  UiIconName2["UserInterface_CloseBold"] = "User_Interface/Close_bold";
  UiIconName2["UserInterface_CloseCircle"] = "User_Interface/Close_circle";
  UiIconName2["UserInterface_CloseThin"] = "User_Interface/Close_thin";
  UiIconName2["UserInterface_Contrast"] = "User_Interface/Contrast";
  UiIconName2["UserInterface_CopyLink"] = "User_Interface/Copy_link";
  UiIconName2["UserInterface_Dashboard"] = "User_Interface/Dashboard";
  UiIconName2["UserInterface_Date"] = "User_Interface/Date";
  UiIconName2["UserInterface_Dislike"] = "User_Interface/Dislike";
  UiIconName2["UserInterface_Edit"] = "User_Interface/Edit";
  UiIconName2["UserInterface_ErrorInSync"] = "User_Interface/Error_In_Sync";
  UiIconName2["UserInterface_ExternalLink"] = "User_Interface/External_Link";
  UiIconName2["UserInterface_Favorite"] = "User_Interface/Favorite";
  UiIconName2["UserInterface_Filter"] = "User_Interface/Filter";
  UiIconName2["UserInterface_FilterWithEllipse"] = "User_Interface/Filter_with_ellipse";
  UiIconName2["UserInterface_Filters"] = "User_Interface/Filters";
  UiIconName2["UserInterface_Fire"] = "User_Interface/Fire";
  UiIconName2["UserInterface_FlashOn"] = "User_Interface/Flash_On";
  UiIconName2["UserInterface_Home"] = "User_Interface/Home";
  UiIconName2["UserInterface_House"] = "User_Interface/House";
  UiIconName2["UserInterface_Hyperlink"] = "User_Interface/Hyperlink";
  UiIconName2["UserInterface_Layer"] = "User_Interface/Layer";
  UiIconName2["UserInterface_Like"] = "User_Interface/Like";
  UiIconName2["UserInterface_Link"] = "User_Interface/Link";
  UiIconName2["UserInterface_Loader"] = "User_Interface/Loader";
  UiIconName2["UserInterface_Loading"] = "User_Interface/Loading";
  UiIconName2["UserInterface_Login"] = "User_Interface/Login";
  UiIconName2["UserInterface_Logout"] = "User_Interface/Logout";
  UiIconName2["UserInterface_Magnifier"] = "User_Interface/Magnifier";
  UiIconName2["UserInterface_MediumVolume"] = "User_Interface/Medium_Volume";
  UiIconName2["UserInterface_Mic"] = "User_Interface/Mic";
  UiIconName2["UserInterface_Minus"] = "User_Interface/Minus";
  UiIconName2["UserInterface_MoreHorizontal"] = "User_Interface/More_horizontal";
  UiIconName2["UserInterface_MoreVertical"] = "User_Interface/More_vertical";
  UiIconName2["UserInterface_Mute"] = "User_Interface/Mute";
  UiIconName2["UserInterface_Necessary"] = "User_Interface/Necessary";
  UiIconName2["UserInterface_Network"] = "User_Interface/Network";
  UiIconName2["UserInterface_NoCamera"] = "User_Interface/No_Camera";
  UiIconName2["UserInterface_NoChatMessage"] = "User_Interface/No_ChatMessage";
  UiIconName2["UserInterface_NoDocument"] = "User_Interface/No_Document";
  UiIconName2["UserInterface_NoDocumentLandscape"] = "User_Interface/No_DocumentLandscape";
  UiIconName2["UserInterface_NoFilter"] = "User_Interface/No_Filter";
  UiIconName2["UserInterface_NoFolder"] = "User_Interface/No_Folder";
  UiIconName2["UserInterface_NoHandbag"] = "User_Interface/No_Handbag";
  UiIconName2["UserInterface_NoImage"] = "User_Interface/No_Image";
  UiIconName2["UserInterface_NoLocation"] = "User_Interface/No_Location";
  UiIconName2["UserInterface_NoMobile"] = "User_Interface/No_Mobile";
  UiIconName2["UserInterface_NoPreview"] = "User_Interface/No_Preview";
  UiIconName2["UserInterface_PageCollection"] = "User_Interface/Page_Collection";
  UiIconName2["UserInterface_Palomna"] = "User_Interface/Palomna";
  UiIconName2["UserInterface_PaperPlane"] = "User_Interface/Paper_Plane";
  UiIconName2["UserInterface_Pen"] = "User_Interface/Pen";
  UiIconName2["UserInterface_Pencil"] = "User_Interface/Pencil";
  UiIconName2["UserInterface_Plus"] = "User_Interface/Plus";
  UiIconName2["UserInterface_PowerButton"] = "User_Interface/Power_Button";
  UiIconName2["UserInterface_Process"] = "User_Interface/Process";
  UiIconName2["UserInterface_Question"] = "User_Interface/Question";
  UiIconName2["UserInterface_Refresh"] = "User_Interface/Refresh";
  UiIconName2["UserInterface_Reload"] = "User_Interface/Reload";
  UiIconName2["UserInterface_Remove"] = "User_Interface/Remove";
  UiIconName2["UserInterface_Research"] = "User_Interface/Research";
  UiIconName2["UserInterface_Save"] = "User_Interface/Save";
  UiIconName2["UserInterface_Setting"] = "User_Interface/Setting";
  UiIconName2["UserInterface_Settings"] = "User_Interface/Settings";
  UiIconName2["UserInterface_Share"] = "User_Interface/Share";
  UiIconName2["UserInterface_SlowVolume"] = "User_Interface/Slow_Volume";
  UiIconName2["UserInterface_Sync"] = "User_Interface/Sync";
  UiIconName2["UserInterface_Taxi"] = "User_Interface/Taxi";
  UiIconName2["UserInterface_Trash"] = "User_Interface/Trash";
  UiIconName2["UserInterface_Upload"] = "User_Interface/Upload";
  UiIconName2["UserInterface_Vibration"] = "User_Interface/Vibration";
  UiIconName2["UserInterface_Volume"] = "User_Interface/Volume";
  UiIconName2["UserInterface_VolumeUp"] = "User_Interface/Volume_Up";
  UiIconName2["UserInterface_Wifi"] = "User_Interface/Wifi";
  UiIconName2["UserInterface_Wifi_"] = "User_Interface/Wifi_!";
  UiIconName2["UserInterface_WifiOff"] = "User_Interface/Wifi_Off";
  UiIconName2["UserInterface_ZoomIn"] = "User_Interface/Zoom_In";
  UiIconName2["UserInterface_ZoomOut"] = "User_Interface/Zoom_Out";
  UiIconName2["UserInterface_CheckCircle"] = "User_Interface/check_circle";
  UiIconName2["UserInterface_DoneBold"] = "User_Interface/done_bold";
  UiIconName2["UserInterface_DoneThin"] = "User_Interface/done_thin";
  UiIconName2["UserInterface_ExclamationPoint"] = "User_Interface/exclamation_point";
  UiIconName2["UserInterface_InfoDown"] = "User_Interface/info_down";
  UiIconName2["UserInterface_InfoUsual"] = "User_Interface/info_usual";
  UiIconName2["UserInterface_Logic"] = "User_Interface/logic";
  UiIconName2["UserInterface_Move2"] = "User_Interface/move_2";
  UiIconName2["UserInterface_Warning"] = "User_Interface/warning";
  UiIconName2["Users_Account"] = "Users/account";
  UiIconName2["Users_AccountInfo"] = "Users/account_info";
  UiIconName2["Users_AccountSmall"] = "Users/account_small";
  UiIconName2["Users_AddAccount"] = "Users/add_account";
  UiIconName2["Users_ApproveUser"] = "Users/approve_user";
  UiIconName2["Users_DeleteUser"] = "Users/delete_user";
  UiIconName2["Users_Profile"] = "Users/profile";
  UiIconName2["Users_Reader"] = "Users/reader";
  UiIconName2["Users_RemoveAccount"] = "Users/remove_account";
  UiIconName2["Users_UserLocation"] = "Users/user_location";
  UiIconName2["Users_Users"] = "Users/users";
  UiIconName2["Logo"] = "logo";
  UiIconName2["LogoFull"] = "logo_full";
  UiIconName2["Stopwatch_24_Outline"] = "stopwatch/24/Outline";
  UiIconName2["ViewCropped"] = "view_cropped";
  UiIconName2["ViewLarge"] = "view_large";
  UiIconName2["ViewMedium"] = "view_medium";
  UiIconName2["ViewOriginal"] = "view_original";
  UiIconName2["ViewSmall"] = "view_small";
  return UiIconName2;
})(UiIconName || {});
export var UiIllustrationName = /* @__PURE__ */ ((UiIllustrationName2) => {
  UiIllustrationName2["FilterRefresh"] = "Filter_refresh";
  UiIllustrationName2["LoadingOutEnd"] = "Loading-_out_end";
  UiIllustrationName2["LoadingReport"] = "Loading-_report";
  UiIllustrationName2["LoadingSucces"] = "Loading-_succes";
  UiIllustrationName2["LoadingWithEnd"] = "Loading-_with_end";
  UiIllustrationName2["LoadingError"] = "Loading-error";
  UiIllustrationName2["NoConnection"] = "No_connection";
  UiIllustrationName2["NoData"] = "No_data";
  UiIllustrationName2["NoImage"] = "No_image";
  UiIllustrationName2["NotFound"] = "Not_found";
  UiIllustrationName2["Palomna"] = "Palomna";
  UiIllustrationName2["Search"] = "Search";
  UiIllustrationName2["Succes"] = "Succes";
  UiIllustrationName2["Table"] = "Table";
  UiIllustrationName2["TableSettings"] = "Table_settings";
  UiIllustrationName2["TechnicalWorkOnThePortal"] = "Technical_work_on_the_portal";
  UiIllustrationName2["Upload"] = "Upload";
  UiIllustrationName2["TheServerIsNotWorking"] = "the_server_is_not_working";
  return UiIllustrationName2;
})(UiIllustrationName || {});
